import { NgModule } from "@angular/core";
import { UiCardComponent } from "./card.component";
import { UiCardLoadingComponent } from "./components/card-loading/card-loading.component";
import { UiCardMetaComponent } from "./components/card-meta/card-meta.component";
import { UiCardTabComponent } from "./components/card-tab/card-tab.component";
import { UiCardGridDirective } from "./directives/card-grid.directive";

@NgModule({
  imports: [UiCardGridDirective, UiCardComponent, UiCardTabComponent, UiCardLoadingComponent, UiCardMetaComponent],
  exports: [UiCardGridDirective, UiCardComponent, UiCardTabComponent, UiCardLoadingComponent, UiCardMetaComponent],
})
export class UiCardModule {}
